import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "scenario-field" }
const _hoisted_2 = { class: "scenario-field-header" }
const _hoisted_3 = { class: "tooltip-container" }
const _hoisted_4 = {
  key: 0,
  class: "fas fa-info-circle"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "text-primary position-relative float-end"
}
const _hoisted_7 = { class: "comment-bubble" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "comment-bubble" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scenario_notes = _resolveComponent("scenario-notes")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card group scenario-field-container", _ctx.selected ? 'active bg-lighter' :''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
        _createElementVNode("span", _hoisted_3, [
          (_ctx.description)
            ? (_openBlock(), _createElementBlock("i", _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: "tooltiptext tooltip-right",
            innerHTML: _ctx.description
          }, null, 8, _hoisted_5)
        ])
      ]),
      (_ctx.windowWidth > 1200 && (_ctx.scenario.data.status !== _ctx.ScenarioStatus.DRAFT) && (_ctx.scenario.data.reviewer_user_id !== null) && _ctx.showCommentBubble)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.scenario?.getCommentsByField(_ctx.field).length > 0 ? _ctx.scenario?.getCommentsByField(_ctx.field).length : ''), 1),
              _cache[0] || (_cache[0] = _createElementVNode("i", {
                class: "fas fa-2x fa-comment-dots",
                title: "View or Read Comments"
              }, null, -1))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.windowWidth < 1200 && (_ctx.scenario.data.status !== _ctx.ScenarioStatus.DRAFT) && (_ctx.scenario.data.reviewer_user_id !== null) && _ctx.showCommentBubble)
        ? (_openBlock(), _createBlock(_component_scenario_notes, {
            key: 1,
            scenario: _ctx.scenario,
            field: _ctx.field,
            "enable-commenting": _ctx.enableComments
          }, {
            trigger: _withCtx((triggerProps) => [
              _createElementVNode("div", {
                onClick: triggerProps.click,
                class: "text-primary position-relative float-end d-flex justify-content-between align-items-center"
              }, [
                _createElementVNode("span", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_ctx.scenario?.getCommentsByField(_ctx.field).length > 0 ? _ctx.scenario?.getCommentsByField(_ctx.field).length : ''), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("i", {
                    class: "fas fa-2x fa-comment-dots",
                    title: "View or Read Comments"
                  }, null, -1))
                ])
              ], 8, _hoisted_8)
            ]),
            _: 1
          }, 8, ["scenario", "field", "enable-commenting"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2))
}